import { createEvent, createStore } from 'effector'

export const actions = {
  setContacts: createEvent<Contact[]>('setContacts'),
  resetContacts: createEvent('resetContacts'),

  reset: createEvent('reset'),
}

const initialState: ContactsState = {
  contacts: [],
}

export const store = createStore<ContactsState>(initialState, { name: 'contacts' })
  .on(actions.setContacts, (s, contacts) => ({ ...s, contacts }))
  .reset(actions.reset)
